import { useMemo } from "react";

interface UseEstimatedCostProps {
  quantity: number;
  isNotional: boolean;
  midPrice: number;
  lastQuote: number;
  limitPrice: number | undefined;
  stopPrice: number | undefined;
}

export const getEstimatedCost = ({
  quantity,
  isNotional,
  midPrice,
  lastQuote,
  limitPrice,
  stopPrice,
}: UseEstimatedCostProps) => {
  if (!quantity || Number.isNaN(quantity)) {
    return "-";
  }

  const orderPrice = limitPrice || stopPrice || midPrice;
  if (!midPrice && !limitPrice) {
    return "-";
  }
  if (!isNotional && !orderPrice) {
    return "-";
  }

  let baseCost: number;
  if (isNotional) {
    baseCost = quantity;
  } else {
    baseCost = orderPrice * quantity;
  }

  const precisionPrice = lastQuote || orderPrice || 1;

  return baseCost.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: precisionPrice < 1.0 ? 4 : 2,
    style: "currency",
    currency: "USD",
  });
};

export const useEstimatedCost = ({
  quantity,
  isNotional,
  midPrice,
  lastQuote,
  limitPrice,
  stopPrice,
}: UseEstimatedCostProps) => {
  const estimatedCost = useMemo(
    () =>
      getEstimatedCost({
        quantity,
        isNotional,
        midPrice,
        lastQuote,
        limitPrice,
        stopPrice,
      }),
    [quantity, isNotional, midPrice, lastQuote, limitPrice, stopPrice],
  );
  return { estimatedCost };
};
